import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  textfield: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});

export default useStyles;
